import React, { useState, SyntheticEvent } from 'react'
import styled, { css } from 'styled-components'
import { VideoPreview as BrandVideoPreview } from '@giphy/react-giphy-brand'
import { giphyDarkestGrey } from '@giphy/js-brand'
import VideoPlayer from './player'
import { mapGifPropsToVideo } from './utils'
import { IVideoGif } from './types'

const ASPECT_RATIO = 16 / 9
const PREVIEW_WIDTH = 376

const Video = styled(BrandVideoPreview)`
    margin: 0;

    ${props =>
        !props.showAttribution &&
        css`
            div[class*='label'] {
                display: none;
            }
        `}
`

const Container = styled.div`
    position: relative;

    ${props =>
        props.isPlaying &&
        css`
            ${Video} > div:first-child {
                display: none;
            }
        `}
`

type Props = {
    height?: number
    onClick?: () => void
    playInline?: boolean
    showAttribution?: boolean
    video: IVideoGif
    width?: number
}

const VideoPreview = ({
    video,
    showAttribution = false,
    playInline = false,
    onClick,
    height,
    width = PREVIEW_WIDTH,
}: Props) => {
    const [isPlaying, setIsPlaying] = useState<boolean>(false)
    const previewHeight = height || width / ASPECT_RATIO
    const playVideoPreview = (e: SyntheticEvent) => {
        e.preventDefault()
        setIsPlaying(true)
    }

    if (!video || !video.images.source) {
        return (
            <div
                style={{
                    backgroundColor: giphyDarkestGrey,
                    height: previewHeight,
                    width: width,
                }}
            />
        )
    }
    return (
        <Container isPlaying={isPlaying}>
            {isPlaying && <VideoPlayer video={video} height={previewHeight} width={width} />}
            <Video
                video={mapGifPropsToVideo(video)}
                playButtonSize={45}
                showAttribution={showAttribution}
                height={previewHeight}
                width={width}
                onClick={playInline ? playVideoPreview : onClick}
            />
        </Container>
    )
}

export default VideoPreview
